import styled from "styled-components";

export const LoginRegisterContainer = styled.div`
  background-color: black;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LoginLogo = styled.img`
  margin-top: 20px;
  margin-bottom: 20px;
  object-fit: contain;
  width: 100px;
  margin-right: auto;
  height: 60px;
  margin-left: auto;
`;

export const LoginContainer = styled.div`
  width: 300px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  border: 1px solid lightgray;
  padding: 20px;
`;

export const LoginContainerHeading = styled.h2`
  font-weight: 500;
  margin-bottom: 20px;
  justify-content: center;
  text-align: center;
  color: gold;
`;

export const InputLabel = styled.h5`
  color: white;
  margin-bottom: 5px;
`;

export const InputField = styled.input`
  height: 30px;
  margin-bottom: 10px;
  background-color: white;
  width: 98%;
`;

export const LoginContainerText = styled.p`
  margin-top: 15px;
  font-size: 12px;
  color: lightgray;
`;

export const LoginButton = styled.button`
  background: gold;
  border-radius: 2px;
  width: 100%;
  height: 30px;
  border: 1px solid;
  margin-top: 10px;
  border-color: wheat;
`;

export const RegisterButton = styled.button`
  border-radius: 2px;
  width: 100%;
  height: 30px;
  border: 1px solid;
  margin-top: 10px;
  border-color: darkgray;
`;
